import React from 'react';
import { Container } from '../common/Container';
import { BOOKING_DURATION_MINUTES, BOOKING_URL, CONTACT_EMAIL } from '../../config/contact';

export const CTA: React.FC = () => {
  return (
    <section className="bg-brand-blue py-20 text-white">
      <Container>
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-center">
          <div>
            <h2 className="text-4xl font-bold tracking-tight text-white">Bring us the workflow that costs you the most time.</h2>
            <p className="mt-3 text-lg text-brand-blue-100">
              In a focused {BOOKING_DURATION_MINUTES}-minute review, we’ll look at your current process and show where Appeal Advantage can remove manual work.
            </p>
          </div>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-lg bg-brand-red px-7 py-4 font-semibold text-white transition-colors hover:bg-brand-red-600"
            >
              Book a workflow review
            </a>
            <a href={`mailto:${CONTACT_EMAIL}?subject=Appeal%20Advantage%20workflow%20review`} className="font-semibold text-white hover:text-red-300">
              Email our team
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};
